import { AxiosError, AxiosRequestConfig } from 'axios';
import { addLocaleToUrl, addSourceAppToSearchParams, cleanSearchParams, getCorrelationId, getCustomContext } from '../utils/commonUtils';
import { httpUtils } from './httpUtils';
import { ServiceRequest } from '../app/ServiceRequest.models';

export const getServiceRequestApi = (requestId: string) => {
  const destinationUrl = addLocaleToUrl('/api/contactus/v1/GetRequest');

  const params = {
    requestId: requestId
  };
  addSourceAppToSearchParams(params);
  cleanSearchParams(params);
  const config: AxiosRequestConfig = {
    params
  };

  return httpUtils
    .get<ServiceRequest>(destinationUrl, config)
    .then((data: ServiceRequest) => {
      console.log('data: %j', data);
      return data;
    })
    .catch((error: AxiosError) => {
      console.log('error: %j', error);
      throw error;
    });
};

export const updateExtensionAttributesApi = (serviceRequest: Partial<ServiceRequest>) => {
  const destinationUrl = addLocaleToUrl('/api/contactus/v1/UpdateExtensionAttributes');

  const params = {};
  addSourceAppToSearchParams(params);
  cleanSearchParams(params);
  const config: AxiosRequestConfig = {
    params
  };

  return httpUtils
    .post<boolean>(destinationUrl, serviceRequest, null, config)
    .then((data: boolean) => {
      console.log('data: %j', data);
      return data;
    })
    .catch((error: AxiosError) => {
      console.log('error: %j', error);
      throw error;
    });
};

export const addLogs = (logHandlerTags: object, correlationId?: string) => {
  if (!!logHandlerTags) {
    var requestHeader = null;
    if (!!correlationId) {
      requestHeader = {
        'Content-Type': 'application/json',
        'X-Correlationid': correlationId
      };
    }
    const destinationUrl = addLocaleToUrl('/api/contactus/v1/AddLogs');
    httpUtils.post<boolean>(destinationUrl, logHandlerTags, requestHeader);
  }
};

export const getAuthTokenApi = () => {
  // Auth token API does not require locale, so we hard code it to en-US.
  // To remove the en-US, we need to work with Magic team to change Akamai rules so the route will be allowed.
  const destinationUrl = '/en-US/api/contactus/oc/v1/GetAuthToken';
  const customContext = getCustomContext();
  const payload = {
    CustomContext: customContext
  };

  const params = {};
  addSourceAppToSearchParams(params);
  cleanSearchParams(params);
  const config: AxiosRequestConfig = {
    params
  };

  return httpUtils
    .post<string>(destinationUrl, payload, null, config)
    .then((data: string) => {
      console.log('data: %j', data);
      return data;
    })
    .catch((error: AxiosError) => {
      console.log('error: %j', error);
      throw error;
    });
};